export default function Mainbecome() {
  return (
    <>
      <div id="main_become" className="container-fluid">
        <div className="row main_become-row">
          <div className="col-sm-4">
            <div className="price-section">
              <article className="price-table">
                <img src={"images/new/5.1.png"} alt="little_bill" className="cards" />
                <h3 className="utilities-head">
                  Mint Your <br/>Little Billionaire
                </h3>
                <p className="little_para main_para" style={{padding:"0px 18px"}}>
                  Mint from a unique collection<br/> of 7,777 collectibles and<br/>
                  benefit from their utilities.
                </p>
              </article>
            </div>
          </div>

          <div className="col-sm-4">
            <div className="price-section">
              <article className="price-table">
                <img src={"images/new/5.2.png"} alt="littl-bill" className="cards" />
                <h3 className="utilities-head">
                  Stake Your <br/>Little Billionaire
                </h3>
                <p className="little_para para__little main_para" style={{padding:"0px 18px"}}>
                  Stake your NFT after the mint<br/> and receive between 50 and<br/> 300
                  $LITTLE tokens every day.
                </p>
              </article>
            </div>
          </div>

          <div className="col-sm-4">
            <div className="price-section">
              <article className="price-table">
                <img src={"images/new/5.3.png"} alt="littl-bill" className="cards" />
                <h3 className="utilities-head">
                  Benefit Like a <br/>Little Billionaire
                </h3>
                <p className="little_para main_para">
                  Benefit from the variety of<br/> utilities, join the Billionaires
                  Club<br/> and be a part of a promising future.
                </p>
              </article>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
